// 内容创作者默认配置
export const defaultConfig = {
  profile: {
    name: "创作者小助手",
    tagline: "多平台内容创作者 | 生活方式·美食·旅行",
    avatar: "",
    bio: "分享生活中的美好瞬间，用心创作每一条内容。已合作品牌50+，专注于生活方式、美食探店、旅行攻略等领域。",
    location: "中国 · 杭州",
    niche: ["生活方式", "美食探店", "旅行攻略"],
    sectionBackground: "#000000",
    fontFamily: "inter",
    fontColor: "#ffffff",
    accentColor: "#8b5cf6"
  },
  // 各平台数据
  platforms: {
    douyin: {
      name: "抖音",
      username: "@创作者小助手",
      url: "https://douyin.com",
      followers: "128.5w",
      works: 328,
      likes: "2560w+",
      avgViews: "50w+"
    },
    xiaohongshu: {
      name: "小红书",
      username: "@创作者小助手",
      url: "https://xiaohongshu.com",
      followers: "45.2w",
      works: 156,
      likes: "320w+",
      avgViews: "10w+"
    },
    bilibili: {
      name: "B站",
      username: "@创作者小助手",
      url: "https://bilibili.com",
      followers: "28.6w",
      works: 89,
      likes: "180w+",
      avgViews: "8w+"
    },
    kuaishou: {
      name: "快手",
      username: "@创作者小助手",
      url: "https://kuaishou.com",
      followers: "65.8w",
      works: 245,
      likes: "890w+",
      avgViews: "30w+"
    },
    xigua: {
      name: "西瓜视频",
      username: "@创作者小助手",
      url: "https://ixigua.com",
      followers: "18.3w",
      works: 112,
      likes: "120w+",
      avgViews: "5w+"
    }
  },
  // 汇总数据
  stats: {
    totalFollowers: "286w+",
    totalWorks: 930,
    totalLikes: "4070w+",
    brandCollabs: 50
  },
  // 作品内容
  works: [
    {
      id: 1,
      title: "杭州必吃美食地图",
      platform: "douyin",
      cover: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=600&h=800&fit=crop",
      description: "本地人推荐的10家宝藏餐厅，人均50吃到撑！",
      likes: "125.6w",
      comments: "3.2w",
      shares: "8.9w",
      views: "580w",
      url: "#",
      publishDate: "2024-12-15"
    },
    {
      id: 2,
      title: "云南7天深度游攻略",
      platform: "xiaohongshu",
      cover: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&h=800&fit=crop",
      description: "人均3000玩转云南，避开人群的小众路线",
      likes: "45.8w",
      comments: "1.8w",
      shares: "32w",
      views: "280w",
      url: "#",
      publishDate: "2024-11-28"
    },
    {
      id: 3,
      title: "Vlog | 自由职业的一天",
      platform: "bilibili",
      cover: "https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=600&h=800&fit=crop",
      description: "不上班月入3万的秘密，我的工作日常大公开",
      likes: "28.6w",
      comments: "2.1w",
      shares: "5.6w",
      views: "156w",
      url: "#",
      publishDate: "2024-11-20"
    },
    {
      id: 4,
      title: "下午茶探店合集",
      platform: "kuaishou",
      cover: "https://images.unsplash.com/photo-1551024709-8f23befc6f87?w=600&h=800&fit=crop",
      description: "5家网红下午茶店真实测评，不踩雷攻略",
      likes: "89.3w",
      comments: "4.5w",
      shares: "12w",
      views: "420w",
      url: "#",
      publishDate: "2024-11-10"
    },
    {
      id: 5,
      title: "新手化妆教程",
      platform: "douyin",
      cover: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=600&h=800&fit=crop",
      description: "0基础也能学会的伪素颜妆，手残党福音",
      likes: "256.8w",
      comments: "12w",
      shares: "45w",
      views: "1200w",
      url: "#",
      publishDate: "2024-10-25"
    },
    {
      id: 6,
      title: "租房改造日记",
      platform: "xiaohongshu",
      cover: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&h=800&fit=crop",
      description: "2000元爆改15平出租屋，房东看了都想涨租",
      likes: "68.2w",
      comments: "2.8w",
      shares: "18w",
      views: "350w",
      url: "#",
      publishDate: "2024-10-15"
    }
  ],
  // 合作信息
  collaboration: {
    types: ["产品测评", "探店打卡", "品牌植入", "直播带货", "活动出席"],
    priceRange: "￥5000-50000",
    brands: ["美妆品牌A", "餐饮集团B", "旅游平台C", "电商平台D"],
    description: "欢迎各品牌方咨询合作，提供专业的内容创作和投放方案。"
  },
  // 社交链接
  social: {
    douyin: "#",
    xiaohongshu: "#",
    bilibili: "#",
    kuaishou: "#",
    weibo: "#",
    wechat: "#"
  },
  // 联系方式
  contact: {
    email: "business@example.com",
    phone: "+86 138 8888 8888",
    wechat: "creator2024",
    wechatQR: "",
    workHours: "工作日 10:00-18:00"
  },
  // 主题配置
  theme: {
    id: 'dark',
    primaryColor: 'violet-500'
  }
};

// 平台颜色配置
export const platformColors = {
  douyin: '#000000',      // 抖音黑
  xiaohongshu: '#ff2442', // 小红书红
  bilibili: '#00a1d6',    // B站蓝
  kuaishou: '#ff6600',    // 快手橙
  xigua: '#ff0000'        // 西瓜红
};

// 平台图标配置
export const platformIcons = {
  douyin: '🎵',
  xiaohongshu: '📕',
  bilibili: '📺',
  kuaishou: '⚡',
  xigua: '🍉'
};

// 平台中文名
export const platformNames = {
  douyin: '抖音',
  xiaohongshu: '小红书',
  bilibili: 'B站',
  kuaishou: '快手',
  xigua: '西瓜视频'
};
